import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

import { CommunicationWidgetEnforceServiceLimit, CommunicationWidgetName } from '@pwp-common';

import { AuthService } from '../../../user/auth/auth.service';
import { CommunicationWidgetService } from '../communication-widget/communication-widget.service';

@Injectable({
  providedIn: 'root',
})
export class CommunicationWidgetEnforceServiceLimitService extends CommunicationWidgetService<CommunicationWidgetEnforceServiceLimit> {
  ///////////////////////////////////////////////////////////////////////
  // Constructor
  ///////////////////////////////////////////////////////////////////////

  constructor(db: AngularFirestore, authService: AuthService) {
    super(db, authService, CommunicationWidgetEnforceServiceLimit);
  }

  ///////////////////////////////////////////////////////////////////////
  // Abstract Methods
  ///////////////////////////////////////////////////////////////////////

  protected getType(): CommunicationWidgetName {
    return CommunicationWidgetName.enforceServiceLimit;
  }
}
